import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './SelectedFiltersDisplay.scss'

const SelectedFiltersDisplay = props => {
  let filteredItems = []

  for (const filter in props.filteredItemLabels) {
    if (!props.excludedFilters.includes(filter)) {
      const filteredLabels = props.filteredItemLabels[filter]
      const filteredLabelsList = filteredLabels?.map((label, idx) => {
        return (
          <li
            key={idx}
            onClick={() => {
              props.onLabelClick(filter, label.meta, label.options)
            }}
          >
            <a>{label.text}</a>
          </li>
        )
      })
      if (filteredLabelsList?.length > 0) {
        filteredItems.push(filteredLabelsList)
      }
    }
  }

  const SelectedFiltersDisplayClass = classNames(
    ['SelectedFiltersDisplay'].concat(props.additionalClassNames),
    {
      'SelectedFiltersDisplay--selected': filteredItems.length > 0
    }
  )

  return (
    <div className={SelectedFiltersDisplayClass}>
      <ul className='SelectedFiltersDisplay__filters'>
        {filteredItems}
        {props.isMobile && filteredItems.length > 0 ? <div className='SelectedFiltersDisplay__clearAll' onClick={() => props.onClearAll()}>Clear All</div> : null}
      </ul>
    </div>
  )
}

SelectedFiltersDisplay.defaultProps = {
  additionalClassNames: [],
  excludedFilters: []
}

SelectedFiltersDisplay.propTypes = {
  additionalClassNames: PropTypes.array,
  excludedFilters: PropTypes.array,
  onLabelClick: PropTypes.func,
  filteredItemLabels: PropTypes.object,
  onClearAll: PropTypes.func,
  isMobile: PropTypes.bool
}
export default SelectedFiltersDisplay
